module.exports = __webpack_public_path__ + "static/media/4.5ec75d41.jpg";